import React, { useContext, useEffect, useState, useRef } from "react";
import { useQuery } from "react-query";
import OrderContext from "../../../context/OrderContext";
import moment from "moment";
import Loader from "../../Loader/Loader";
import Modal from "react-modal";
import ModalComments from "./Modals/comments";
import ModalDetails from "./Modals/details";
import ModalInvoces from "./Modals/invoces";
import ModalShippingLabel from "./Modals/shippinglabel";
import AuthContext from "../../../context/AuthContext";
import { useTranslation } from "react-i18next";

const OrderTable = () => {
  let { user } = useContext(AuthContext);
  let {
    page,
    limit,
    orderby,
    shippingstatus,
    orderstatus,
    search,
    processed,
    vendor,

    from,
    to,

    fetchData,
    orderPeocess,
    orderVisable,
    modalIsOpen,
    closeModal,
    isCommentsModalOpen,
    isDetailsModalOpen,
    isInvocesModalOpen,
    isSLModalOpen,
    statusChange,
    getComments,
    getOrderDetails,
    getInvoces,
    getShippingLabel,
    putSentStatus,
  } = useContext(OrderContext);

  const [t, i18n] = useTranslation("common");

  const { isSuccess, isLoading, isFetching, data } = useQuery(
    [
      "order",
      page,
      limit,
      orderby,
      shippingstatus,
      orderstatus,
      search,
      processed,
      vendor,
      from,
      to,
      statusChange,
    ],
    ({ queryKey }) =>
      fetchData(
        queryKey[1],
        queryKey[2],
        queryKey[3],
        queryKey[4],
        queryKey[5],
        queryKey[6],
        queryKey[7],
        queryKey[8],
        queryKey[9],
        queryKey[10],
        queryKey[11],
        queryKey[12]
      ),
    { keepPreviousData: true }
  );

  const handleVisibleOrder = (id, status) => {
    orderVisable(id, status);
  };

  const getMyComments = (el) => {
    if (user.username != "budapester") {
      let filterObj = el.filter((item) => item.author === user.username);
      return filterObj.length;
    } else {
      return el.length;
    }

  };

  return (
    <>
      {isLoading && <Loader></Loader>}
      {isSuccess & !isFetching ? (
        <table className="table table-striped nowrap">
          <thead>
            <tr>
              {user.roles.includes("ROLE_all-seeing") && (
                <th>{t("app.Vendors")}</th>
              )}
              <th>{t("app.Customer")}</th>
              <th>{t("app.OrderDate")}</th>
              <th>{t("app.Phone")}</th>
              <th>{t("app.OrderID")}</th>
              <th>{t("app.Comments")}</th>
              <th></th>
              <th>{t("app.Status")}</th>
            </tr>
          </thead>
          <tbody>
            {data.list.length > 0 ? (
              data.list.map((row) => (
                <tr
                  key={row.orderId}
                  id={`${row.orderId}-element`}
                  className="asd"
                >
                  {user.roles.includes("ROLE_all-seeing") && (
                    <td>
                      <div className="ml-4">
                        {row.vendors
                          .filter(
                            (v, i, a) =>
                              a.findIndex((v2) => v2.id === v.id) === i
                          )
                          .map((vendor) => (
                            <div key={row.vendors.indexOf(vendor)}>
                              {vendor.name}
                              <br />
                            </div>
                          ))}
                      </div>
                    </td>
                  )}
                  <td>
                    <span
                      className={`${!user.roles.includes("ROLE_all-seeing") ? "ml-4" : ""
                        }`}
                    >
                      {row.customer.shipping.name}
                    </span>{" "}
                  </td>
                  <td>{moment(row.saleTime).format("DD/MM/YY")}</td>
                  {/* <td>{row.status}</td> */}
                  <td>{row.customer.shipping.phoneNumber}</td>
                  <td>{row.magentoInternalId}</td>
                  <td className="font-md">
                    <i
                      type="button"
                      className="ml-4 feather icon-message-square"
                      onClick={() => getComments(row.orderId)}
                    >
                      {getMyComments(row.comments) > 0 ? (
                        <span className="pcoded-badge label label-primary">
                          {getMyComments(row.comments)}
                        </span>
                      ) : (
                        ""
                      )}
                    </i>
                  </td>
                  <td>
                    <button
                      className="btn btn-outline-secondary btn-buble"
                      data-tip=""
                      data-for={`${row.orderId}-details`}
                      onClick={() => getOrderDetails(row.orderId)}
                    >
                      {t("app.Details")}{" "}
                      <b className="buble-btn">{row.products.length}</b>
                    </button>
                    <button
                      type="button"
                      className={
                        row.shipping.length > 0 && row.shipping[0].printedAt
                          ? "btn btn-secondary redbtn"
                          : "btn btn-secondary"
                      }
                      disabled={`${!row.shipping.length > 0 ? "disabled" : ""}`}
                      onClick={() => getShippingLabel(row.orderId)}
                    >
                      {t("app.ShippingLabel")}
                    </button>

                    {row.vendorAwareStatus === "completed" && (
                      <button
                        className={
                          row.sentStatuses.length > 0 &&
                            row.sentStatuses[0].isSent
                            ? "btn btn-secondary redbtn"
                            : "btn btn-secondary isDsiabled"
                        }
                        id={`row-versendet-${row.orderId}`}
                        onClick={() =>
                          putSentStatus(
                            row.orderId,
                            row.sentStatuses[0].vendor.id
                          )
                        }
                      >
                        VERSENDET
                      </button>
                    )}
                  </td>
                  <td>
                    <ul className="processed-stat-info">
                      <li>
                        {row.products.find((u) => !u.verifiedAt) ? (
                          <>
                            <span id={`stoct-check-${row.orderId}`}></span>
                            <p>{t("app.Stock")}</p>
                          </>
                        ) : row.products.find(
                          (u) => u.availability === "not_available"
                        ) ? (
                          <>
                            <span
                              className="danger"
                              id={`stoct-check-${row.orderId}`}
                            ></span>
                            <p>{t("app.Stock")}</p>
                          </>
                        ) : (
                          <>
                            <span
                              className="success"
                              id={`stoct-check-${row.orderId}`}
                            ></span>
                            <p>{t("app.Stock")}</p>
                          </>
                        )}
                      </li>
                      {user.roles.includes("ROLE_all-seeing") &
                        (row.vendorAwareStatus === "awaiting") ? (
                        <button
                          className={`btn btn-cross ${row.visible ? "" : "active"
                            }`}
                          id={`row-visible-${row.orderId}`}
                          onClick={() =>
                            handleVisibleOrder(row.orderId, row.visible)
                          }
                        >
                          x
                        </button>
                      ) : (
                        " "
                      )}
                    </ul>
                  </td>
                  <td>
                    {row.shipping.shippingCompany === "dhl_express" && (
                      <span className="dhl_express_label">DHL EXPRESS</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9}>
                  <span className="ro-res">{t("app.Search")} No results</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      ) : (
        ""
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
      >
        {isCommentsModalOpen && <ModalComments />}
        {isDetailsModalOpen && <ModalDetails />}
        {isInvocesModalOpen && <ModalInvoces />}
        {isSLModalOpen && <ModalShippingLabel />}
      </Modal>
    </>
  );
};

export default OrderTable;
